/* eslint-disable react/button-has-type */
import React from 'react';

import styles from './LegacyButton.module.scss';

export type Kind =
  | 'primary'
  | 'secondary'
  | 'accentPrimary'
  | 'accentSecondary'
  | 'negativePrimary'
  | 'negativeSecondary';

export type Size = 'small' | 'large';

export type Type = 'button' | 'submit' | 'reset';

export interface LegacyButtonProps {
  text?: string;
  onClick?: () => void;
  isLoading?: boolean;
  disabled?: boolean;
  kind?: Kind;
  size?: Size;
  type?: Type;
  userRole?: string;
  full?: boolean;
  outline?: boolean;
}
const LegacyButton: React.FC<LegacyButtonProps> = ({
  text,
  children,
  onClick,
  isLoading = false,
  disabled = false,
  kind = 'primary',
  size = 'small',
  type = 'button',
  userRole = 'anonymous',
  full = false,
  outline = false,
}) => (
  <button
    data-testid="defaultButton"
    className={`${styles.button}
        ${styles[size]}
        ${isLoading || disabled ? styles.disabled : styles[kind]}
        ${styles[userRole]}
        ${full ? `${styles.full}` : ''}
        ${outline ? `${styles.outline}` : ''}
        `}
    type={type}
    onClick={onClick}
    disabled={isLoading || disabled}
  >
    {text || children}
  </button>
);

export default LegacyButton;
